import styled from "styled-components";
import { StyledMenuItemProps } from "./types";

export const StyledMenuItemContainer = styled.div<StyledMenuItemProps>`
  position: relative;
  ${({ $isActive, $variant, theme }) =>
    $isActive &&
    $variant === "subMenu" &&
    `
      &:after{
        content: "";
        position: absolute;
        bottom: 0;
        height: 4px;
        width: 100%;
        background-color: ${theme.colors.primary};
        border-radius: 2px 2px 0 0;
      }
    `}; 
  border-bottom:2px solid ${({ theme, $isActive }) => ( $isActive ? theme.colors.text : "none" )};
  width:120px !important;
`;

const StyledMenuItem = styled.a<StyledMenuItemProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size:18px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.text};
  font-size: 16px;
  font-weight:400;
  font-family: 'Marcellus';
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
  ${({ $statusColor, theme }) =>
    $statusColor &&
    `
    &:after {
      content: "";
      border-radius: 100%;
      background: ${theme.colors[$statusColor]};
      height: 8px;
      width: 8px;
      margin-left: 12px;
    }
  `}

  ${({ $variant }) =>
    $variant === "default"
      ? `
    // padding: 0 16px;
    height: 48px;
  `
      : `
    padding: 4px 4px 0px 4px;
    height: 42px;
  `}
  > svg {
      fill:${({ theme }) => theme.colors.text};
  }
`;

export default StyledMenuItem;
